import css from "./VirtualKioskSettings.scss";
import Switch from "common/Switch";
import VirtualCheckInSchedule from "./VirtualCheckInSchedule";
import React from "react";
import PropTypes from "prop-types";
import {SFVirtualCheckInModifySchedule} from "utils/types";

const VirtualCheckInAvailability = (props) => {
    // When enabling the feature, automatically add an initial slot if the schedule is empty.
    // When disabling the feature, automatically remove empty rows to help avoid validation errors.
    const updateSchedulePlaceholder = (checked) => {
        if (checked && props.checkInSchedule.length === 0) props.modifyCheckInSchedule.addDayRow();
        if (!checked) {
            props.modifyCheckInSchedule.clearEmptyRows();
            props.modifyCheckInSchedule.validate();
        }
    }

    return (
        <div className={css['virtual-check-in']}>
            <div className={css['enable-virtual-check-in']}>
                <Switch id="enableVirtualCheckInHours"
                        aria-label="Set availability for virtual check in"
                        disabled={!!props.error}
                        checked={props.virtualCheckInScheduleEnabled}
                        onChange={(checked) => {
                            updateSchedulePlaceholder(checked);
                            props.setVirtualCheckInScheduleEnabled(checked)
                        }} />
                <label htmlFor="enableVirtualCheckInHours" className={css["label"]}>Limit Availability for Virtual Check-in</label>
                <div className={css['enableVirtualCheckInHoursInfo']}>
                    When turned on, below you can limit Virtual Check-In to a set of desired hours.
                    Outside of these days/hours, this virtual kiosk will be hidden and its direct link will
                    not allow student to check-in.
                </div>
                {props.virtualCheckInScheduleEnabled &&
                <div className={css['virtual-availability']}>
                    <div className={css['check-in-header']}>Virtual Check-in Availability</div>
                    <div className={css['timezone']}>
                        {`All Time selections will be based on your tenant's time zone: `}
                        <span>{props.timezone}</span>.
                    </div>
                    <div className={css['choose-hours']}>Choose Virtual Check-in Open Hours</div>
                    <p className={css['info']}>
                        You can select multiple time slots for each day you want to allow Virtual Check-in.
                        For specific closed dates, you can manually disable Virtual Check-in.
                        You must Save Changes for any changes to take effect.
                        After saving, your time slots will automatically be ordered from Monday to Sunday.
                    </p>
                    <VirtualCheckInSchedule {...props} />
                </div>}
            </div>
        </div>
    );
}

VirtualCheckInAvailability.propTypes = {
    error: PropTypes.string,
    modifyCheckInSchedule: SFVirtualCheckInModifySchedule,
    setVirtualCheckInEnabled: PropTypes.func,
    setVirtualCheckInScheduleEnabled: PropTypes.func,
    virtualCheckInEnabled: PropTypes.bool,
    virtualCheckInScheduleEnabled: PropTypes.bool,
    ...VirtualCheckInSchedule.props
}

export default VirtualCheckInAvailability;
